module.exports = __webpack_public_path__ + "img/bg-default.cb1abfb0.jpg";